<template>
   

<button type="button" class="btn btn-success" @click="download">
  <font-awesome-icon icon="plus" />下載派件明細表
</button>
 <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    header="下載派件明細表"
    :modal="true"
    class="p-fluid"
    :style="{width: '80vw', 'min-height':'100vh'}" :position="position"
  >
    <component
      :is="component_name"
      :iden="item.iden"
      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>

  

</template>

<script>
import service from "../service/Appservice";
export default {
   props: {
    msg: String
  },
  data() {
    return {
      data: null,
      isShowDialog: false,
    };
  },
  inject:['params'],
  computed: {
    user() {
     return this.$store.state.user;
    },
     agentNo() {
     return this.$store.state.user?.agentNo;
    },
     
  },
  service: null,
  created() {
    this.service = new service();
  },
  methods: {
    ////////搜尋/////////////////////////////////////
      download() {


      this.service.downloadImpSendReport(this.params)
        .then((response) => {

          console.log('download')
          console.log(response)
          console.log(response.data)
          console.log(response.data.type)
          
          let filename='派件分區明細表.xlsx'
           var blob = new Blob([response.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename)
          } else {
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob) // 建立下載的連結
            downloadElement.href = href
            downloadElement.download = filename // 下載後檔名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 點選下載
            document.body.removeChild(downloadElement) // 下載完成移除元素
            window.URL.revokeObjectURL(href) // 釋放掉blob物件
          }


          

        });
    },
    
  }
}
</script>
 